export default __webpack_public_path__ + "9fa7c0c3398ba434739b3c7c1e3b15b7.png";